import { render } from "./UCFNavBar.vue?vue&type=template&id=63aabd61"
import script from "./UCFNavBar.vue?vue&type=script&lang=js"
export * from "./UCFNavBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__